import axios from "axios";
export interface AutomaticStockConfig {
  enabled: boolean;
  defaultQuantity: number;
  includeDrinks: boolean;
  meals: Array<{ mealId: string; enabled: boolean; quantity: number | null }>;
  sharedPools?: Array<{ groupId: string; quantity: number }>;
}
export interface AutomaticStockPool { _id: string; name: string; description?: string; }
export interface AutomaticStockMeal {
  id: string; name: string; image?: string;
  category?: { _id: string; name: string; displayOrder?: number };
  kind: "meal" | "drink" | null; sourceName: string | null;
  sharedStockGroupId: string | null; ambiguous: boolean;
}
export interface StockPreview {
  warnings?: string[];
  meals: Array<{ mealId: string; name: string; isScheduled: boolean; stockMode: string; plannedQuantity: number | null;
    source: string; reason: string; swapSetSerial?: number | null; sharedStockGroupId?: string | null }>;
}
const base = `${process.env.REACT_APP_API_URL || ""}/api/admin/daily-availability/automatic-stock`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });
export const instantAutomaticStockApi = {
  get: async (kitchenId: string): Promise<{ config: AutomaticStockConfig; catalogue: AutomaticStockMeal[]; sharedStockGroups?: AutomaticStockPool[] }> =>
    (await axios.get(base, { ...auth(), params: { kitchenId } })).data,
  save: async (kitchenId: string, config: AutomaticStockConfig) =>
    (await axios.patch(base, { kitchenId, config }, auth())).data,
  preview: async (kitchenId: string, date: string): Promise<{ preview: StockPreview }> =>
    (await axios.get(`${base}/preview`, { ...auth(), params: { kitchenId, date } })).data,
};
